import { useContext, useMemo } from 'react';
import UserContextProvider from 'interface/interfaces';
import * as userServices from 'service/userServices';

export function useIsLoggedIn(): boolean {
  const ctx = useContext(UserContextProvider);
  const stored = userServices.getCurrentUser?.(); // puede venir de localStorage

  // true si hay id, uid, email o token en contexto o storage
  return useMemo(() => {
    const byContext = !!ctx?.user && !!((ctx.user.id && ctx.user.id !== 0) || ctx.user.uid || (ctx.user.email && ctx.user.email.trim() !== ''));
    const byStored  = !!stored && !!((stored.id && stored.id !== 0) || stored.uid || (stored.email && stored.email.trim() !== '') || stored.access_token);
    return byContext || byStored;
  }, [ctx?.user, stored]);
}
